// Svelte 5 no longer needs svelte/store imports for basic reactivity

// Create reactive state for the modal (private - not exported)
export const modalState = $state({ selected: null });

// Function to show a modal
export function showModal(modalName) {
    modalState.selected = modalName;
}

// Function to hide the modal
export function hideModal() {
    modalState.selected = null;
}